// extracted by mini-css-extract-plugin
module.exports = {"spl_bull_list":"STstyle_spl_bull_list__F1jfQ","LBStructured":"STstyle_LBStructured__e7gQG","ritualHeading":"STstyle_ritualHeading__SQBfU"};